<template>
  <b-modal :id="modalId" :title="modalTitle" no-close-on-backdrop @hidden="resetForm">
    <b-form @submit.prevent="onSubmit">
      <b-form-group v-if="showCabang" label="Cabang">
        <multiselect
          v-model="forms.cabang"
          :options="optionsCabang"
          :internal-search="true"
          :allow-empty="true"
          deselect-label=""
          select-label=""
          label="name"
          track-by="id"
          placeholder="-- Pilih Cabang --"
          :name="`${modalId}-cabang`"
        />
      </b-form-group>
      <b-form-group v-if="showFromType" label="Dari">
        <b-form-select
          v-model="forms.fromType"
          :options="fromTypeOptions"
          :name="`${modalId}-from-type`"
        >
          <template v-slot:first>
            <b-form-select-option :value="null">-- Pilih Dari --</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
      <b-form-group v-if="showToType" label="Tujuan">
        <b-form-select
          v-model="forms.toType"
          :options="availableToTypeOptions"
          :name="`${modalId}-to-type`"
        >
          <template v-slot:first>
            <b-form-select-option :value="null">-- Pilih Tujuan --</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Nominal">
        <b-input-group prepend="Rp.">
          <b-form-input
            v-model="forms.nominal"
            :name="`${modalId}-nominal`"
            maxlength="17"
            @keydown="onNominalKeydown"
          />
        </b-input-group>
      </b-form-group>
      <b-form-group label="Keterangan (Opsional)" class="mb-0">
        <b-form-textarea
          v-model="forms.keterangan"
          rows="3"
          :name="`${modalId}-keterangan`"
          maxlength="100"
        />
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" :name="`${modalId}-cancel`" @click="cancel()">
        Batal
      </b-button>
      <b-button
        variant="pgiBtn"
        :name="`${modalId}-submit`"
        :disabled="isSubmitting"
        @click="onSubmit"
      >
        {{ isSubmitting ? "Menyimpan..." : submitLabel }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ModalInputOperasionalKas",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    submitLabel: {
      type: String,
      default: "Simpan",
    },
    optionsCabang: {
      type: Array,
      required: true,
    },
    showCabang: {
      type: Boolean,
      default: true,
    },
    showFromType: {
      type: Boolean,
      default: false,
    },
    showToType: {
      type: Boolean,
      default: false,
    },
    fromTypeOptions: {
      type: Array,
      default: () => [],
    },
    toTypeOptions: {
      type: Array,
      default: () => [],
    },
    defaultFromType: {
      type: [Number, String],
      default: null,
    },
    defaultToType: {
      type: [Number, String],
      default: null,
    },
    enforceDifferentType: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forms: {
        cabang: null,
        fromType: this.defaultFromType,
        toType: this.defaultToType,
        nominal: "0",
        keterangan: "",
      },
    };
  },
  computed: {
    availableToTypeOptions() {
      const source = this.showToType ? this.toTypeOptions : [];
      if (!this.enforceDifferentType) return source;
      if (this.forms.fromType == null) return source;
      return source.filter((item) => Number(item.value) !== Number(this.forms.fromType));
    },
  },
  methods: {
    normalizeTypeDefaults() {
      if (!this.showFromType) {
        this.forms.fromType = this.defaultFromType;
      }
      if (!this.showToType) {
        this.forms.toType = this.defaultToType;
      }
    },
    onSubmit() {
      if (this.showCabang && this.forms.cabang == null) {
        this.$helper.toastErr(this, "Cabang wajib dipilih.");
        return;
      }
      if (this.showFromType && this.forms.fromType == null) {
        this.$helper.toastErr(this, "Dari wajib dipilih.");
        return;
      }
      if (this.showToType && this.forms.toType == null) {
        this.$helper.toastErr(this, "Tujuan wajib dipilih.");
        return;
      }
      if (this.enforceDifferentType && Number(this.forms.fromType) === Number(this.forms.toType)) {
        this.$helper.toastErr(this, "Tujuan harus beda dari Dari.");
        return;
      }
      const nominalValue = this.$helper.removeThousandSeparator(this.forms.nominal);
      if (!nominalValue || nominalValue <= 0) {
        this.$helper.toastErr(this, "Nominal wajib lebih dari 0.");
        return;
      }

      this.$emit("submit", {
        cabang: this.forms.cabang,
        fromType: Number(this.forms.fromType),
        toType: Number(this.forms.toType),
        nominal: nominalValue,
        keterangan: this.forms.keterangan,
      });
    },
    resetForm() {
      this.forms = {
        cabang: null,
        fromType: this.defaultFromType,
        toType: this.defaultToType,
        nominal: "0",
        keterangan: "",
      };
    },
    onNominalKeydown(event) {
      const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Enter"];
      if (allowedKeys.includes(event.key)) return;
      if (event.ctrlKey || event.metaKey) return;
      if (!/^[0-9.]$/.test(event.key)) event.preventDefault();
    },
    formatNominalValue(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  watch: {
    defaultFromType() {
      this.forms.fromType = this.defaultFromType;
    },
    defaultToType() {
      this.forms.toType = this.defaultToType;
    },
    "forms.fromType": function(newValue) {
      if (!this.enforceDifferentType) return;
      if (newValue == null) return;
      const availableOptions = this.toTypeOptions.filter((item) => Number(item.value) !== Number(newValue));
      if (availableOptions.length === 1) {
        this.forms.toType = availableOptions[0].value;
        return;
      }
      if (Number(newValue) === Number(this.forms.toType)) {
        this.forms.toType = null;
      }
    },
    "forms.nominal": function(newValue) {
      let cleanValue = this.$helper.changeToValue(newValue);
      let digitValue = cleanValue
        .replace(/[^0-9]/g, "")
        .replace(/^0+(?=\d)/, "");
      let result = this.formatNominalValue(digitValue);
      while (result.length > 17 && digitValue.length > 0) {
        digitValue = digitValue.slice(0, -1);
        result = this.formatNominalValue(digitValue);
      }
      this.$nextTick(() => {
        this.forms.nominal = result === "" ? "0" : result;
      });
    },
  },
  created() {
    this.normalizeTypeDefaults();
  },
};
</script>
